<script setup>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';

defineProps({
  status: String,
});

const form = useForm({
  email: '',
});

const submit = () => {
  form.post(route('password.email'));
};
</script>

<template>
  <Head title="Forgot Password" />

  <JetAuthenticationCard>
    <template #logo>
      <div v-if="$settings.login_logo_url" class="my-2 w-80 max-w-full mx-auto flex items-end justify-center">
        <img :src="$settings.login_logo_url" :alt="$settings.name" class="max-h-full max-w-full rounded object-cover" />
      </div>
      <JetAuthenticationCardLogo v-else />
    </template>

    <div class="mb-4 text-sm text-gray-600">
      Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you
      to choose a new one.
    </div>

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <JetValidationErrors class="mb-4" />

    <form @submit.prevent="submit">
      <div>
        <JetLabel for="email" value="Email" />
        <JetInput id="email" v-model="form.email" type="email" class="mt-1 block w-full" required autofocus />
      </div>

      <div class="flex items-center justify-end mt-4 gap-4">
        <Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900"> Login </Link>
        <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing"> Email Reset Link </JetButton>
      </div>
    </form>
  </JetAuthenticationCard>
</template>
